// extracted by mini-css-extract-plugin
export default {"fr-view":"QuestionText_fr-view__6hKy5","correct-answer":"QuestionText_correct-answer__7fgSf","text":"QuestionText_text__pebFd"};